import { useQuery } from '@tanstack/react-query';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';
import useErrorHandler from '../../../hooks/useErrorHandler';
import { useTenant } from '../../../contexts/TenantContext';

// What `providerId` offers and can start then (docs/MULTI_PROVIDER.md).
const useGetAvailableSupplies = ({ date, startTime, providerId, enabled }) => {
  const { tenantId } = useTenant();
  const { handleError } = useErrorHandler();

  return useQuery({
    queryKey: ['availableSupplies', tenantId, date, startTime, providerId],
    queryFn: async () => {
      try {
        const response = await apiClient.get(`/v1/public/tenants/${tenantId}/supplies/available`, {
          params: { date, startTime, providerId },
        });
        return response.data;
      } catch (error) {
        handleError(error, Routes.DASHBOARD);
        throw error;
      }
    },
    enabled: !!tenantId && !!date && !!startTime && enabled,
    // Never served from cache. What fits changes under the admin — their own manual booking, a
    // guest in the funnel — and a 5-minute cache kept offering supplies the server then rejected.
    // The modal clears its slot on close, so with no gcTime every opening starts from nothing.
    staleTime: 0,
    gcTime: 0,
  });
};

export default useGetAvailableSupplies;